/**
 * TKT-2026-107434: the FALLBACK sign for a currency code, nothing more.
 *
 * The store's sign comes from sortswift-api's one currency list, through the
 * display config (`currencySymbol` on /kiosk-config/theme and verify-pin). This
 * file used to be the kiosk's own copy of that list, and every currency a store
 * asked for had to be added here by hand (NOK printed "NOK12.00" until it was).
 *
 * It is only reached when the config carries no sign: an older backend, or a
 * kiosk formatting from its cache before the config lands. Intl draws the sign;
 * its narrow "$" is refused for anything but USD (a Canadian price must never
 * read as dollars), falling back to the plain sign ("CA$") and then the code.
 */

const cache = new Map();

function intlSign(code, currencyDisplay) {
    const part = new Intl.NumberFormat('en-US', { style: 'currency', currency: code, currencyDisplay })
        .formatToParts(1)
        .find((p) => p.type === 'currency');
    return part && part.value ? part.value : null;
}

export function getCurrencySymbol(code) {
    if (typeof code !== 'string' || !/^[A-Z]{3}$/.test(code)) return code || '$';
    if (cache.has(code)) return cache.get(code);
    let sign = code;
    try {
        const narrow = intlSign(code, 'narrowSymbol');
        if (narrow && (narrow !== '$' || code === 'USD')) {
            sign = narrow;
        } else {
            const plain = intlSign(code, 'symbol');
            if (plain && plain !== '$') sign = plain;
        }
    } catch {
        sign = code;
    }
    cache.set(code, sign);
    return sign;
}
